import { createFileRoute } from "@tanstack/react-router";

import { TrustDocumentPage } from "@/components/legal/trust-document-page";
import { multiResumeBrand } from "@/utils/multiresume-brand";

export const Route = createFileRoute("/privacy")({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: `Privacy - ${multiResumeBrand.appName}` }],
  }),
});

function RouteComponent() {
  return <TrustDocumentPage documentKey="privacy" />;
}
